import { CustomFile } from './custom-file';

export class CustomFilesList
{
    private _files: CustomFile[] = [];
    get files ()
    {
        return this._files;
    }

    add (file: CustomFile): void
    {
        this._files.push(file);
    }

    remove (id: string): void
    {
        this._files = this._files.filter((f) => f.id !== id);
    }

    clear (): void
    {
        this._files = [];
    }
}
